import { get, isEmpty } from 'lodash'

const isLoading = state => get(state, 'existingClientsWatchOnFlyStatusLoad.loading')
const hasErrors = state => !isEmpty(get(state, 'existingClientsWatchOnFlyStatusLoad.error'))

export const selectors = {
  isLoading,
  hasErrors,
}
